module.exports = __webpack_public_path__ + "static/media/uni-gauge.b2fe907b.png";